import { serialize } from 'next-mdx-remote/serialize'
import { MDXRemote, MDXRemoteSerializeResult } from 'next-mdx-remote'
import fs from 'fs';
import { client } from '../../../sanity/lib/client';
import { PortableText } from '@portabletext/react';
import imageUrlBuilder from '@sanity/image-url'
import { useElementSize, useMediaQuery } from '@mantine/hooks';
import { Badge, Box, Button, Divider, Image, Paper, Text } from '@mantine/core';
import { Logo, MiniLogo } from '@/components/Logo';
import { AnyService } from '../../../../types/global';
import { ArrowRight } from 'tabler-icons-react';
import Link from 'next/link';
import BlogLayout from '@/layouts/Blog.layout';

export function urlFor(source: string) {
    return imageUrlBuilder(client).image(source)
}

const logoBar = [
    "Google Analytics",
    "Facebook Pages",
    "Meta Ads",
    "Instagram"
] as Array<AnyService>

export default function Post({ post }: { post: any }) {
    const mobile = useMediaQuery("(max-width: 540px)")
    if (!post) return null
    return (
        <BlogLayout>
            <article style={{ width: "100%" }}>

                <img src={(urlFor(post.mainImage.asset._ref).width(750).maxHeight(400).fit("crop")) as unknown as string} style={{ borderRadius: 10, maxWidth: "100%" }} />


                {/* <h1>{post.title}</h1> */}
                <Text fw={600} fz={35}>{post.title}</Text>
                <Box className='flex' style={{ gap: 10, flexWrap: "wrap" }}>
                    {post.categories?.map((c: string) => <Badge radius={"sm"} variant="light">{c}</Badge>)}
                </Box>
                <Box mt={20}>
                    <PortableText
                        value={post.body}
                    />
                </Box>
                <Box className='flex' style={{ gap: 10 }} mt={30}>
                    {/* @ts-ignore */}
                    <img src={urlFor(post.authorImage).width(40).height(40).maxHeight(40).fit("scale")} style={{ borderRadius: 100 }} />
                    <Box>
                        <Text fw={600} fz="sm" c="dimmed">Written By</Text>
                        <Text lh={1} fw={600}>{post.name}</Text>
                    </Box>

                </Box>
                <Divider my={20} />
                <Paper p={0} radius={"lg"} className={`flex ${mobile ? "fdc" : "aic jcsb"}`} style={{ gap: mobile ? 10 : 20 }}>
                    <Box className={`flex ${mobile ? "fdc" : "aic"}`} style={{ gap: mobile ? 12 : 0 }}>
                        <Box className='flex' style={{ gap: 5, flexWrap: 'wrap', maxWidth: mobile ? undefined : 75, width: "fit-content" }}>
                            {logoBar.map((l) => <Box bg={"gray.0"} p={5} style={{ borderRadius: 20 }} className="flex aic jcc"> <Image width={15} height={15} style={{ objectFit: "contain", width: 15, height: 15 }} src={`/images/logos/${l.toLowerCase().replaceAll(" ", "_")}.png`} /></Box>)}
                        </Box>
                        <Box>
                            {/* <Logo width={150} /> */}
                            <Text lh={1} fz="xl" fw={600}>Simplify your onboarding process</Text>
                            <Text c="dimmed">Start using AgencyAccess today to simplify onboarding for your clients</Text>
                        </Box>
                    </Box>
                    <Link href={"/pricing"}>
                        <Button variant={"default"} rightSection={<ArrowRight size={20} />}>Get Started</Button>
                    </Link>
                </Paper>
                {/* <Divider my={20} /> */}
            </article>
        </BlogLayout>
    )
}

// export async function getStaticPaths() {
//     const paths = await client.fetch(
//         `*[_type == "post"][].slug.current`
//     )

//     console.log(paths)

//     return {
//         paths: paths.map((slug: string) => ({ params: { slug } })),
//         fallback: false,
//     }
//     // const filenames = fs.readdirSync(`${process.cwd()}/public/blogs`);
//     // const paths: string[] = [];
//     // filenames.forEach((id) => { paths.push(`/blog/${id.replace(".mdx", "")}`) })
//     // return { paths, fallback: false };
// }

export async function getServerSideProps({ params }: { params: { slug: string } }) {
    const { slug } = params
    const post = await client.fetch(`
    *[_type == "post" && slug.current == $slug][0]{title, "name": author->name, "authorImage": author->image, body, categories, mainImage, "categories": categories[]->title}
  `, { slug })

    if (!post) {
        return {
            notFound: true
        }
    }

    return {
        props: {
            post
        }
    }
    // const file = fs.readFileSync(`${process.cwd()}/public/blogs/${params.slug}.mdx`, "utf-8")
    // const mdxSource = await serialize(file, { parseFrontmatter: true })
    // return { props: { mdxSource } }
}